import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../../config/config";
const BlogSide = () => {
  const { slug } = useParams();
  const [blogs, setBlogs] = useState([]);
  const imageBaseURL = `${BASE_URL}/employees/view/`;

  useEffect(() => {
    axios
      .get(`${BASE_URL}/blogs/list`)
      .then((res) => {
        if (res.data.success) {
          const allBlogs = res.data.data;

          // Remove current blog from list
          const filtered = allBlogs.filter((item) => {
            const blogSlug = item.title.replace(/\s+/g, "-").toLowerCase();
            return blogSlug !== slug;
          });

          // Limit to first 6 posts (optional)
          setBlogs(filtered.slice(0, 6));
        }
      })
      .catch((err) => console.error(err));
  }, [slug]);

  return (
    <div className="bg-[#ECF1F6] rounded-xl p-4 w-full max-w-sm mx-auto shadow-lg">
      <h2 className="text-lg font-bold border-b border-gray-700 mb-4">
        Other Posts
      </h2>

      {blogs.map((post, idx) => {
        const imageUrl = `${imageBaseURL}${post.image?.split("/").pop()}`;

        return (
          <Link
            to={`/blog/${post.title.replace(/\s+/g, "-").toLowerCase()}`}
            key={idx}
            className="block cursor-pointer"
          >
            <div className="flex items-start gap-4 border-b border-gray-700 py-4 last:border-none">
              <img
                src={imageUrl}
                alt={post.alt || post.title}
                className="w-20 h-20 object-cover rounded-md flex-shrink-0"
              />
              <div>
                <h3 className="text-sm font-semibold leading-snug line-clamp-2">
                  {post.title}
                </h3>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default BlogSide;
